package com.appcreator.dto

import kotlinx.serialization.Serializable

@Serializable
data class InvitationsResponse(
    val invitations: List<Invitation>
)